import { put, takeEvery, select } from 'redux-saga/effects';
import { websiteSelector } from 'common/selectors';
import { fetchVideoApi } from 'common/api';
import queryString from 'query-string';
import { doFetch } from 'utils/api';
import { addAnimatedThumbnailAction, LOAD_ANIMATED_THUMBNAIL_DATA } from './actions';
import { get } from 'lodash-es';

const cacheBackgroundImage = (url) => {
  return new Promise((resolve) => {
    const img = document.createElement('img');
    img.onload = resolve;
    img.src = url;
  });
};

function* loadAnimatedThumbnail({ payload: { videoId } }) {
  const website = yield select(websiteSelector);
  const playerConfiguration = get(website, 'playerConfiguration');

  if (playerConfiguration) {
    const { playerDefinitionId, playerApiDomain } = playerConfiguration;

    try {
      const { playerToken } = yield fetchVideoApi(videoId);
      const params = playerToken ? `${queryString.stringify({ token: playerToken })}` : '';

      const { storyboard, duration } = yield doFetch(
        `/play/player/${playerDefinitionId}/video/${videoId}?${params}`,
        {},
        `//${playerApiDomain}`
      );
      yield cacheBackgroundImage(storyboard.sources[0]);
      yield put(addAnimatedThumbnailAction(videoId, { ...storyboard, duration }));
    } catch (error) {
      // newrelic already notified
    }
  }
}

export const saga = function* () {
  yield takeEvery(LOAD_ANIMATED_THUMBNAIL_DATA, loadAnimatedThumbnail);
};
